<template>
  <div>

    <!-- 头 -->
    <div v-if="showSearchArea">
      <van-nvabar title="产品列表"
                  fixed
                  @click-right="onClickRight">
        <template #right>
          <van-icon name="search"
                    size="18" />
        </template>
      </van-nvabar>
      <div style="border:1px solid lightgrey;margin-top:47px"></div>
    </div>
    <!-- 搜索 -->
    <div v-if="!showSearchArea">
      <van-search v-model="keyWord"
                  show-action
                  placeholder="请输入搜索关键词"
                  @search="onSearch"
                  @cancel="onCancel"></van-search>
    </div>
    <!-- 列表 -->

    <!-- 加载 -->
    <!-- <div style="text-align:center;margin-top:50%"
         v-if="loading">
      <van-loading color="#ff5421"
                   size="44px">加载中...</van-loading>
    </div> -->

    <van-list v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">

      <div v-for="item in prodinfo"
           :key="item.spu_id">
        <vant-card :desc="item.operator"
                   :title="item.title"
                   :thumb="item.prod_image">
          <!-- 目的地 -->
          <template #tags>
            <van-tag v-for="tag_item,index in item.dest"
                     style="margin-right:5px;margin-top:5px"
                     :key="index"
                     plain
                     type="danger">{{tag_item}}</van-tag>
          </template>
          <!-- 按钮 -->
          <template #footer>
            <van-button @click="clickProduct(item)"
                        color="#ff5421"
                        size="small">查看介绍</van-button>
            <van-button @click="makeResveration(item)"
                        style="margin-left:10px"
                        color="#ff5421"
                        size="small">预定活动</van-button>
          </template>
        </vant-card>

        <div style="border:1px solid lightgrey"></div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { Button } from 'vant'
import { Card } from 'vant'
import { Tag } from 'vant'
import { Divider } from 'vant'
import { NavBar } from 'vant'
import { Icon } from 'vant'
import { Search } from 'vant'
import { Loading } from 'vant'
import { List } from 'vant'

export default {
  name: 'm_product_list',
  components: {
    'vant-card': Card,
    'van-button': Button,
    'van-tag': Tag,
    'van-divider': Divider,
    'van-nvabar': NavBar,
    'van-icon': Icon,
    'van-search': Search,
    'van-loading': Loading,
    'van-list': List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      showSearchArea: true,
      keyWord: '',
      prodinfo: [],
      pagenum: 1,
      pagesize: 16,
      //页数
      pagecount: -1,
      // 总数量
      total: -1,
      query: '',
    }
  },
  mounted() {
    this.getProdInfo()
  },
  methods: {
    onLoad() {
      console.log('ssssss')

      if (this.pagenum == this.pagecount) {
        this.finished = true
      } else {
        this.pagenum = this.pagenum + 1
        this.getProdInfo()
      }
    },
    onClickRight() {
      this.showSearchArea = false
      this.prodinfo = []
    },
    // 点击键盘上的搜索/回车按钮后触发
    onSearch() {
      this.pagenum = 1
      this.getProdInfo()
    },
    onCancel() {
      this.showSearchArea = true
      this.prodinfo = []
      this.keyWord = ''
      this.getProdInfo()
    },
    makeResveration(item) {
      this.$router.push({ path: `/m_make_resveration?spu_id=${item.spu_id}` })
    },
    clickProduct(item) {
      // this.$router.push({ path: `/product-inrto` });
      this.$router.push({
        path: `/m_product_introduce`,
        query: { spu_id: `${item.spu_id}` },
      })
    },
    getProdInfo() {
      this.loading = true
      this.$http
        .get(
          `/product/get_product_list?p_no=${this.pagenum}&p_size=${this.pagesize}&key_word=${this.keyWord}`
        )
        .then((res) => {
          console.log(res)
          const { data, errno, errmsg } = res.data
          this.pagecount = res.data.pages
          this.total = res.data.product_account

          for (let pro of data) {
            // 建立对象，并将对象 push到列表
            let item = {}
            item.spu_id = pro.spu_id
            item.title = pro.spu_name
            item.updataDate = pro.last_update_time
            item.prod_image = pro.spu_avatar
            item.dest = pro.dest
            item.operator = pro.operator
            this.prodinfo.push(item)
            // console.log(this.prodinfo);
            // 套餐名称，和id，添加到列表中
            item.sku_pkg = pro.sku
          }
          this.loading = false
          //console.log(this.prodinfo);
        })
    },
  },
}
</script>

<style>
</style>